import type { FiscalPeriod } from "./types";

export const fiscalPeriodsGrouped: Record<FiscalPeriod, string[]> = {
	FY: ["FY"],
	QTR: ["Q4", "Q3", "Q2", "Q1"],
	TTM: ["FY", "Q3TTM", "Q2TTM", "Q1TTM"],
};
